import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from "rxjs";
import { PaginationModel, ProductCategoryModel, RequestParamModel } from '@coreModels';
import { ApiConstants } from '@coreConstant';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService {

  /**
   * Constructor for the class which initializes the service dependency.
   * @return {void}
   */
  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Fetches the list of product categories based on the provided request parameters.
   *
   * @param {RequestParamModel} requestParamModel - The parameters to be sent with the API request.
   * @*/
  getCategories(requestParamModel: RequestParamModel): Observable<any> {
    return this.http.get(ApiConstants.PRODUCT_CATEGORY_LISTS_URL+ requestParamModel.getParams(), { observe: 'response' })
      .pipe(
        map<any, any>(response => {
          const responseData = new PaginationModel<ProductCategoryModel>();
          const headers = response.headers;
          responseData.setHeaders(headers);
          responseData.data = response.body.data as ProductCategoryModel[];
          return responseData;
        }),
        catchError((err: any) => {
          return throwError(err); // You can customize the error handling here
        })
      );
  }
}
